import { render } from "./OnService.vue?vue&type=template&id=c68332e2"
import script from "./OnService.vue?vue&type=script&lang=js"
export * from "./OnService.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__